<div class="container-fluid">
  <div>
    <div class="page-header">
      <h3>Hello, world!</h3>
    </div>
    <div style="padding-left: 16px">
      <p>Welcome to the new Field Sciences Payment System website</p>
    </div>


    <div class="col-sm-12" style="padding: 0">
      @for (myLinkGroup of MyLinkGroups(); track myLinkGroup) {
        <div>
          <div class="page-header">
            <h3>{{myLinkGroup.groupdisplayName}}</h3>
          </div>
          <mat-nav-list class="quickLinks-no-scroll" style="padding: 0">
            @for (myLink of myLinkGroup.quicklinks; track myLink) {
              <mat-list-item (click)="navigateTo(myLink)">
                <a style="color: #0072CE;">{{myLink.displayName}}</a>
              </mat-list-item>
            }
          </mat-nav-list>
        </div>
      }
    </div>
  </div>
</div>
